/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormalizedProjectRevisionThirdPartyProvider { 
    additional_id_token_audiences?: Array<string>;
    apple_private_key?: string | null;
    /**
     * Apple Private Key Identifier  Sign In with Apple Private Key Identifier needed for generating a JWT token for client secret
     */
    apple_private_key_id?: string;
    /**
     * Apple Developer Team ID  Apple Developer Team ID needed for generating a JWT token for client secret
     */
    apple_team_id?: string;
    /**
     * AuthURL is the authorize url, typically something like: https://example.org/oauth2/auth Should only be used when the OAuth2 / OpenID Connect server is not supporting OpenID Connect Discovery and when `provider` is set to `generic`.
     */
    auth_url?: string;
    /**
     * Tenant is the Azure AD Tenant to use for authentication, and must be set when `provider` is set to `microsoft`.  Can be either `common`, `organizations`, `consumers` for a multitenant application or a specific tenant like `8eaef023-2b34-4da1-9baa-8bc8c9d6a490` or `contoso.onmicrosoft.com`.
     */
    azure_tenant?: string;
    claims_source?: string | null;
    /**
     * ClientID is the application\'s Client ID.
     */
    client_id?: string;
    client_secret?: string | null;
    /**
     * The Project\'s Revision Creation Date
     */
    readonly created_at?: string;
    id?: string;
    /**
     * IssuerURL is the OpenID Connect Server URL. You can leave this empty if `provider` is not set to `generic`. If set, neither `auth_url` nor `token_url` are required.
     */
    issuer_url?: string;
    /**
     * Label represents an optional label which can be used in the UI generation.
     */
    label?: string;
    /**
     * Mapper specifies the JSONNet code snippet which uses the OpenID Connect Provider\'s data (e.g. GitHub or Google profile information) to hydrate the identity\'s data.
     */
    mapper_url?: string;
    organization_id?: string | null;
    /**
     * PKCE controls if the OpenID Connect OAuth2 flow should use PKCE (Proof Key for Code Exchange). Possible values are: `auto` (default), `never`, `force`. `auto`: PKCE is used if the provider supports it. Requires setting `issuer_url`. `never`: Disable PKCE entirely for this provider, even if the provider advertises support for it. `force`: Always use PKCE, even if the provider does not advertise support for it. OAuth2 flows will fail if the provider does not support PKCE. IMPORTANT: If you set this to `force`, you must whitelist a different return URL for your OAuth2 client in the provider\'s configuration. Instead of <base-url>/self-service/methods/oidc/callback/<provider>, you must use <base-url>/self-service/methods/oidc/callback (Note the missing <provider> path segment and no trailing slash).
     */
    pkce?: NormalizedProjectRevisionThirdPartyProvider.PkceEnum | null;
    /**
     * The Revision\'s ID this schema belongs to
     */
    project_revision_id?: string;
    /**
     * Provider is either \"generic\" for a generic OAuth 2.0 / OpenID Connect Provider or one of: generic google github gitlab microsoft discord slack facebook vk yandex apple
     */
    provider?: string;
    /**
     * ID is the provider\'s ID
     */
    provider_id?: string;
    requested_claims?: object;
    scope?: Array<string>;
    /**
     * State indicates the state of the provider  Only providers with state `enabled` will be used for authentication enabled ThirdPartyProviderStateEnabled disabled ThirdPartyProviderStateDisabled
     */
    state?: NormalizedProjectRevisionThirdPartyProvider.StateEnum;
    subject_source?: string | null;
    /**
     * TokenURL is the token url, typically something like: https://example.org/oauth2/token  Should only be used when the OAuth2 / OpenID Connect server is not supporting OpenID Connect Discovery and when `provider` is set to `generic`.
     */
    token_url?: string;
    /**
     * Last Time Project\'s Revision was Updated
     */
    readonly updated_at?: string;
}
export namespace NormalizedProjectRevisionThirdPartyProvider {
    export type PkceEnum = 'auto' | 'never' | 'force';
    export const PkceEnum = {
        Auto: 'auto' as PkceEnum,
        Never: 'never' as PkceEnum,
        Force: 'force' as PkceEnum
    };
    export type StateEnum = 'enabled' | 'disabled';
    export const StateEnum = {
        Enabled: 'enabled' as StateEnum,
        Disabled: 'disabled' as StateEnum
    };
}


